import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './goodsTypes.state';
import getters from './goodsTypes.getters';
import actions from './goodsTypes.actions';
import mutations from './goodsTypes.mutations';

BaseStore.registerModule('goodsTypes', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('goodsTypes');

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};